import React, { Fragment, useState } from 'react'
import Cover from './Cover'
import Contain from './Contain'

export default (props) => {
  const {
    type = 'cover',
    src,
    shape = 'sharp',
    title = '',
    alt = '',
    className,
    style,
    width = 'auto',
    height = 'auto',
    errorImgSrc,
    onError,
    ...rest
  } = props || {}
  const [src2, setSrc2] = useState(src)

  const handleImgLoadError = () => {
    if (errorImgSrc) {
      setSrc2(props.errorImgSrc)
    }
    props.onError && props.onError()
  }
  const params = {
    type,
    src: src2,
    shape,
    title,
    alt,
    className,
    style,
    width,
    height,
    errorImgSrc,
    ...rest,
  }

  return (
    <Fragment>
      {type === 'contain' && <Contain {...params} onError={handleImgLoadError} />}
      {type === 'cover' && <Cover {...params} onError={handleImgLoadError} />}
    </Fragment>
  )
}
